/**
 * Admin workspace settings client (PR E — Settings view).
 *
 * Two endpoints:
 *   - GET  /api/admin/workspace  — readable by any tenant member
 *   - PUT  /api/admin/workspace  — admin-only (backend gates)
 *
 * Types from the OpenAPI generator so backend schema drift surfaces
 * as a TS error here, not at runtime.
 */

import apiClient from "./client";
import type { components } from "@/types/api.generated";

export type WorkspaceSettings =
  components["schemas"]["WorkspaceSettingsResponse"];
export type UpdateWorkspaceSettingsPayload =
  components["schemas"]["UpdateWorkspaceSettingsRequest"];

export async function getWorkspaceSettings(): Promise<WorkspaceSettings> {
  const res = await apiClient.get<WorkspaceSettings>("/api/admin/workspace");
  return res.data;
}

export async function updateWorkspaceSettings(
  payload: UpdateWorkspaceSettingsPayload,
): Promise<WorkspaceSettings> {
  const res = await apiClient.put<WorkspaceSettings>(
    "/api/admin/workspace",
    payload,
  );
  return res.data;
}
